// Player states reported by the YouTube IFrame API's getPlayerState().
const VIDEO_UNSTARTED = -1;
const VIDEO_ENDED = 0;
const VIDEO_PLAYING = 1;
const VIDEO_PAUSED = 2;
const VIDEO_BUFFERING = 3;
const VIDEO_CUED = 5;

export {
    VIDEO_UNSTARTED,
    VIDEO_ENDED,
    VIDEO_PLAYING,
    VIDEO_PAUSED,
    VIDEO_BUFFERING,
    VIDEO_CUED,
};
